import { useNavigate } from "react-router-dom";
import BoothMark from "./BoothMark";
import "./Hero.css";

function Hero() {
  const navigate = useNavigate();

  return (
    <header id="top" className="booth-shell booth-hero">
      <p className="booth-hero-eyebrow">Step inside</p>
      <BoothMark as="h1" className="booth-hero-title" />
      <p className="booth-hero-dek">
        Every matchup in your fantasy league, filed as a story the night the games end, with the evidence
        behind every line.
      </p>
      <div className="booth-hero-actions">
        <button type="button" className="booth-btn booth-btn--primary" onClick={() => navigate("/auth")}>
          Add your league <span aria-hidden="true">→</span>
        </button>
        <a href="#sample" className="booth-link-underline">
          Read a sample dispatch
        </a>
      </div>
      <p className="booth-hero-trust">Works with ESPN and Sleeper. Free while we're in beta.</p>
    </header>
  );
}

export default Hero;
